
export default function getHashOrDefault(def) {
    if (!window.location.hash) return def;

    return window.location.hash.substr(1);
}